import { create } from './create';
import { deleteEndpoint } from './delete';
import { list } from './list';
import { patch } from './patch';

export { type PatchSavedViewPayload } from './patch';
export { type CreateSavedViewPayload } from './create';

export const savedViews = {
  list,
  patch,
  create,
  delete: deleteEndpoint,
};
